import cn from 'classnames';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IKnmActFamiliarizationNotificationsForm } from 'KnmErknmPackage/MainModule/interfaces/IKnmActFamiliarizationNotificationsForm';
import { Row } from 'UIPackage/FormModule/components/Row';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';
import { composeValidators } from 'CorePackage/MainModule/validators/composeValidators';
import { makeMaxCharactersValidator } from 'CorePackage/MainModule/validators/maxCharacters';
import { MAX_CHARACTERS_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { CloseButton } from 'UIPackage/MainModule/components/CloseButton';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';
import { SelectInputFieldAutoOptions } from 'UIPackage/MainModule/components/SelectInputFieldAutoOptions';

import styles from './KnmActIntroductionItem.module.scss';

interface IErknmActIntroductionItemProps {
  fieldValue: IKnmActFamiliarizationNotificationsForm;
  id: string;
  name: string;
  isDisabledField: boolean;
  remove: () => void;
  isPm?: boolean;
  isDecision?: boolean;
}

export const KnmActIntroductionItem = ({
  id,
  name,
  fieldValue,
  isDisabledField,
  remove,
  isDecision,
  isPm,
}: IErknmActIntroductionItemProps) => {
  const { isNew } = fieldValue;

  return (
    <Row id={id} isListItem key={id}>
      <FieldBlock
        size="col-3"
        id={`${id}.knmNoticeType`}
        label={getTitleFieldWithRedStar({
          label: 'Способ уведомления',
          field: `${name}.knmNoticeType`,
          isPm,
          isDecision,
          isKnm: !isPm && !isDecision,
        })}
      >
        <SelectInputFieldAutoOptions
          name={`${name}.knmNoticeType`}
          disabled={isDisabledField}
          size="medium"
          optionName={CommonCatalogsNamesEnum.KNM_NOTICE_METHODS}
        />
      </FieldBlock>
      <FieldBlock
        size="col-3"
        id={`${id}.noticeDate`}
        label={getTitleFieldWithRedStar({
          label: 'Дата уведомления',
          field: `${name}.noticeDate`,
          isPm,
          isDecision,
          isKnm: !isPm && !isDecision,
        })}
      >
        <DatePickerField name={`${name}.noticeDate`} disabled={isDisabledField} maxDate={new Date()} />
      </FieldBlock>
      <FieldBlock
        size="col-3"
        id={`${id}.note`}
        label={getTitleFieldWithRedStar({
          label: 'Примечание',
          field: `${name}.note`,
          isPm,
          isDecision,
          isKnm: !isPm && !isDecision,
        })}
      >
        <TextInputField
          name={`${name}.note`}
          disabled={isDisabledField}
          validate={composeValidators(makeMaxCharactersValidator(8000, MAX_CHARACTERS_ERROR))}
        />
      </FieldBlock>
      {!isDisabledField && (
        <CloseButton
          className={cn('shared-deleting-row-btn', styles.DeleteButton, { [styles.isShowBtnDel]: !isNew })}
          onClick={remove}
          disabled={!isNew}
        />
      )}
    </Row>
  );
};
